import React, { Component } from 'react';
import TagComponent from '../skill/tag.component'
class ProjectComponent extends Component {
    render() {
        return (
            <li className="project">
                <h2>{this.props.projectName}</h2>
                <p>{this.props.intro}
                    <a href={this.props.url} target="_blank">link</a>
                    <br />
                    {this.props.description}
                </p>
                <TagComponent items={this.props.tags} />
            </li>
        );
    }
}

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/components/project/project.component.jsx